import { createContext } from "react"

export const ScenarioContext = createContext(0)
